const range = "_range_40c3c_1";
const styles = {
  range
};
export {
  styles as default,
  range
};
//# sourceMappingURL=Range.module.scss.js.map
